import {
  AppointmentDetailDto,
  AppointmentListData,
  WorkScheduleListData,
} from "@/models/club";
import { ClickEventSlotProps } from "@/pages/dashboard/calendar/type";
import moment from "moment-jalaali";

// export enum AppointmentStatus {
//   Pending = "PENDING",
//   Scheduled = "SCHEDULED",
//   Confirmed = "CONFIRMED",
//   Cancelled = "CANCELLED",
//   Completed = "COMPLETED",
// }

export type CalendarEvent = AppointmentDetailDto & {
  merchantUserColor?: string;
};
export interface Partner {
  id: number;
  name: string;
  events: CalendarEvent[];
}

export interface CalendarViewProps {
  currentDate: moment.Moment | undefined;

  partners?: AppointmentListData;
  onEventClick?: (event: CalendarEvent) => void;
  onEmptySlotClick?: (props: ClickEventSlotProps) => void;
  isPersian: boolean;
  loading: boolean;
  shiftSchedule?: WorkScheduleListData;

  setSelectedEvent?: (event: CalendarEvent | null) => void;
}

export interface MonthViewProps extends CalendarViewProps {
  matches: boolean | undefined;
  partners?: AppointmentListData;
  view: ViewType;
  // Opens the day view for a date (month cell number).
  onOpenDay?: (day: moment.Moment) => void;
}

export interface EventItemProps {
  event: CalendarEvent;
  setSelectedEvent?: (event: CalendarEvent | null) => void;
  onEventClick?: (event: CalendarEvent) => void;
  view?: ViewType | "grid";
}

export type ViewType = "day" | "week" | "month";

export interface JalaaliCalendarProps {
  view: ViewType;
  onEventClick?: (event: CalendarEvent) => void;
  setView: (view: ViewType) => void;
  partners?: AppointmentListData;
  currentDate?: moment.Moment;
  onEmptySlotClick?: (props: ClickEventSlotProps) => void;
  setCurrentDate: (date: moment.Moment | ((prev: moment.Moment) => moment.Moment)) => void;
  loading: boolean;
  shiftSchedule?: WorkScheduleListData;
  selectedEvent?: CalendarEvent | null;
  setSelectedEvent?: (event: CalendarEvent | null) => void;
  // Previous range is still shown while the new one loads.
  stale?: boolean;
  // Team-member filter shown in the toolbar (desktop).
  members?: { selected: number; total: number; open: () => void };
}

export const sortEventsByTime = (events: CalendarEvent[] = []) => {
  return [...events].sort((a, b) => {
    const timeA = moment(a.startTime);
    const timeB = moment(b.startTime);
    return timeA.diff(timeB);
  });
};

export const getWeekDays = (isPersian: boolean) => {
  const weekDays = isPersian
    ? ["شنبه", "یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه"]
    : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return weekDays;
};
